export function broadcastAnalyzeUrlLaunchToGrabCADPrint() {
    window.grabcadPrintContextBridge?.analyzeUrlLaunched?.();
}
